var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStStorm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_368_3858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 68,
    height: 68,
    rx: 34,
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5455,
    y: 11.5455,
    width: 64.9091,
    height: 64.9091,
    rx: 32.4545,
    stroke: "white",
    strokeWidth: 3.09091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6667 33.2778C54.2892 28.2248 49.4174 25 44 25C38.5826 25 33.7108 28.2248 31.3333 33.2778C27.7672 33.7707 25 37.0161 25 40.9188C25 45.1707 28.2738 48.6214 32.3077 48.6214H34.2564C35.0554 48.6214 35.7179 47.9231 35.7179 47.0809C35.7179 46.2388 35.0554 45.5404 34.2564 45.5404H32.3077C29.8913 45.5404 27.9231 43.4658 27.9231 40.9188C27.9231 38.3718 29.8913 36.2972 32.3077 36.2972C32.8923 36.2972 33.4379 35.9275 33.6523 35.3524C35.4062 30.9362 39.4595 28.0811 44 28.0811C48.5405 28.0811 52.5938 30.9362 54.3477 35.3524C54.5815 35.9275 55.1077 36.2972 55.6923 36.2972C58.1087 36.2972 60.0769 38.3718 60.0769 40.9188C60.0769 43.4658 58.1087 45.5404 55.6923 45.5404H51.7949C50.9959 45.5404 50.3333 46.2388 50.3333 47.0809C50.3333 47.9231 50.9959 48.6214 51.7949 48.6214H55.6923C59.7262 48.6214 63 45.1707 63 40.9188C63 37.0161 60.2328 33.7913 56.6667 33.2778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9487 45.5406H42.8307L45.2082 41.7817C45.6564 41.0833 45.481 40.1179 44.7989 39.6455C44.1364 39.173 43.2205 39.3579 42.7723 40.0768L38.8748 46.2389C38.5825 46.7114 38.5436 47.3276 38.7969 47.8205C39.0502 48.3135 39.5374 48.6422 40.083 48.6422H43.201L40.8236 52.401C40.3754 53.0994 40.5507 54.0648 41.2328 54.5372C41.4861 54.7221 41.7589 54.8043 42.0512 54.8043C42.5189 54.8043 42.9866 54.5578 43.2595 54.1264L47.1569 47.9643C47.4492 47.4919 47.4882 46.8757 47.2348 46.3827C46.9815 45.8897 46.4943 45.5611 45.9487 45.5611V45.5406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2093 52.3804C53.6637 51.5177 52.3191 51.5177 51.7734 52.3804L49.5129 55.9544C48.7529 57.1458 48.558 58.6863 49.0063 60.0625C49.4155 61.3566 50.3509 62.322 51.5201 62.7533C51.9878 62.9176 52.475 62.9998 53.0401 62.9998C54.5601 62.9793 55.8852 62.096 56.6257 60.6377C57.3857 59.1177 57.2883 57.2896 56.4114 55.8928L54.1898 52.401L54.2093 52.3804ZM54.0534 59.1998C53.917 59.4669 53.6247 59.8982 52.9816 59.8982C52.8063 59.8982 52.6309 59.8777 52.4555 59.816C52.0463 59.6723 51.8514 59.3231 51.7734 59.056C51.6175 58.5836 51.6955 58.0496 51.9488 57.6593L52.9816 56.0161L53.9755 57.5977C54.3263 58.1728 54.2483 58.8096 54.0339 59.2204L54.0534 59.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2826 52.3804C35.7369 51.5177 34.3923 51.5177 33.8467 52.3804L31.5862 55.9544C30.8262 57.1458 30.6313 58.6863 31.0795 60.0625C31.4887 61.3566 32.4241 62.322 33.5933 62.7533C34.061 62.9176 34.5482 62.9998 35.1133 62.9998C36.6333 62.9793 37.9585 62.096 38.699 60.6377C39.459 59.1177 39.3615 57.2896 38.4846 55.8928L36.2631 52.401L36.2826 52.3804ZM36.1267 59.1998C35.9903 59.4669 35.698 59.8982 35.0549 59.8982C34.8795 59.8982 34.7041 59.8777 34.5287 59.816C34.1195 59.6723 33.9246 59.3231 33.8467 59.056C33.6908 58.5836 33.7687 58.0496 34.0221 57.6593L35.0549 56.0161L36.0487 57.5977C36.3995 58.1728 36.3215 58.8096 36.1072 59.2204L36.1267 59.1998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_368_3858",
    x: -0.818182,
    y: -0.818182,
    width: 89.6364,
    height: 89.6364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.40909
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.537255 0 0 0 0 0.568627 0 0 0 0 0.611765 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_3858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_3858",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStStorm);
export default __webpack_public_path__ + "static/media/st_storm.e09e461681a8deb12213dd68e0fc2ed1.svg";
export { ForwardRef as ReactComponent };